import React, { useState } from "react";
import { DatePicker } from "antd-jalali";
import styles from "./RangePicker.module.css";
import { Note } from "../Note";
import dayjs from "dayjs";
const RangePicker = (props) => {
  const { className, currentRange = [], onGetRange } = props;

  const [startValue, setStartValue] = useState(
    currentRange.length &&
      currentRange[0] &&
      dayjs(currentRange[0], { jalali: false })
  );
  const [endValue, setEndValue] = useState(
    currentRange.length &&
      currentRange[1] &&
      dayjs(currentRange[1], { jalali: false })
  );
  const handleStartChange = (value) => {
    setStartValue(value);
    console.log(value);
    onGetRange([value, endValue]);
  };
  const handleEndChange = (value) => {
    const start = new Date(startValue).getTime();
    const end = new Date(value).getTime();
    if (start > end) {
      setEndValue(null);
      return Note.error("End date must be after start date");
    }
    setEndValue(value);
    onGetRange([startValue, value]);
  };

  return (
    <div className={`${styles.RangePickerContainer} ${className}`}>
      <DatePicker
        placeholder="Start Date"
        className={styles.Item}
        value={startValue}
        onChange={handleStartChange}
      />
      <DatePicker
        placeholder="End Date"
        className={styles.Item}
        value={endValue}
        onChange={handleEndChange}
      />
    </div>
  );
};

export default RangePicker;
